module.exports = __webpack_public_path__ + "static/media/Kh.d4056cad.png";